import { IAttrValue } from "@multiweb/types/contracts";
import { AttrValueReader } from "OW.Remoting/Remoting/AttrValueReader";
import { CheckBoxUtils } from "../../../../UI.ElementarControls/Helpers/CheckBoxUtils";
import { ItemTemplate } from "../ItemTemplate";

export class BooleanTemplate extends ItemTemplate {
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        item.innerHTML = "";
        item.appendChild(this._createCheckboxElement(dataSet));
    }

    private _createCheckboxElement(dataSet?: IAttrValue[]): HTMLDivElement {
        const cdiv = document.createElement("div");
        const cbox = document.createElement("input");
        const clabel = document.createElement("label");

        cbox.type = "checkbox";
        cdiv.classList.add("CheckBox", "checkboxDiv", "checkboxDivNotDisplayed");

        cdiv.appendChild(cbox);
        cdiv.appendChild(clabel);

        const data = this._getDataFromSet(dataSet);
        CheckBoxUtils.setCheckValue(cbox, AttrValueReader.read(data));

        return cdiv;
    }
}
